import { FilterContainer as Container } from "./styles";

export function FilterContainer({ children }) {
  return <Container>{children}</Container>;
}
